// Import necessary libraries
import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';

// AdminDashboard component
const AdminDashboard = () => {
  // Access user information from AuthContext
  const { user } = useAuthContext();

  // Check if the user is admin
  const isAdmin = user?.email.toLowerCase() === 'admin@freshjuiceglobal.com';

  // Render content based on admin status
  return (
    <div>
      {isAdmin ? (
        // Display admin content here
        <h1>Welcome to Admin Dashboard!</h1>
      ) : (
        // Display access denied message
        <h1>Access Denied. You are not authorized to view this page.</h1>
      )}
    </div>
  );
};

export default AdminDashboard;
